import { render, staticRenderFns } from "./SacScoreLevels.vue?vue&type=template&id=6ccc1ed5"
import script from "./SacScoreLevels.vue?vue&type=script&lang=js"
export * from "./SacScoreLevels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports